import React, { useEffect, useState } from 'react'
import { useCategory } from '../hooks/useCategory'
import PageHead from '../components/PageHead';
import Loading from '../components/Loading';
import Container from '../ui/comp/Container';
import Table from '../ui/Table/Table';
import Thead from '../ui/Table/Thead';
import Td from '../ui/Table/Td';
import Tbody from '../ui/Table/Tbody';
import Avatar from '../ui/comp/Avatar';
import { displayImage, exportButton } from '../utils/config';
import { CgEye, CgTrash } from 'react-icons/cg';
import { FiEdit, FiPlus } from 'react-icons/fi';
import Button from '../ui/comp/Button';
import { CiExport } from 'react-icons/ci';
import Input from '../ui/forms/Input';
import AddCategory from '../components/categories/AddCategory';
import UpdateCategory from '../components/categories/UpdateCategory';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Axios } from '../utils/Axios';


function Category() {

    const navigate = useNavigate();
    const location = useLocation();

    const queryClient = useQueryClient()

    const { data: categoriesData, isLoading, error } = useCategory();
    const [isAddCategoryOpen, setIsAddCategoryOpen] = useState(false)
    const [isUpdateCategoryOpen, setIsUpdateCategoryOpen] = useState(false)
    const [categories, setcategories] = useState([])
    const [searchText, setSearchText] = useState("")

    useEffect(() => { setcategories(categoriesData) }, [categoriesData])

    // Delete Category

    const { mutate } = useMutation({
        mutationFn: async (id) => {
            const res = await Axios.delete(`/category/delete?id=${id}`);
            return res.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['category'])
        }
    })

    const deleteCategory = (id) => {
        if (window.confirm("Are you sure, you want to delete")) {
            mutate(id)
        }
    }

    if (isLoading) {
        return <><Loading /></>
    }

    if (error) {
        return <div>Error occured</div>
    }

    return (
        <div className='w-full relative'>

            {/* Add Category */}
            {isAddCategoryOpen && <AddCategory onClose={() => setIsAddCategoryOpen(false)} />}

            {/* Update Category */}
            {isUpdateCategoryOpen && <UpdateCategory onClose={() => {
                const searchparams = new URLSearchParams(location.search);
                searchparams.delete('category');
                navigate(`${location.pathname}?${searchparams.toString()}`)
                setIsUpdateCategoryOpen(false)
            }}
            />}


            <PageHead title={"Categories"} />


            {/* Filter palce */}
            <div className="flex items-center justify-between w-full mt-8">
                <div className='max-w-48 w-full'>
                    <Button
                        onClick={() => exportButton("categories")}
                        color={'primary'}
                        icon={<CiExport size={18} />}
                    >
                        Export
                    </Button>
                </div>

                <div className='flex items-center gap-3'>
                    <Input placeholder="Category Name" onChange={(e) => setSearchText(e.target.value)} />
                    <Button onClick={() => setIsAddCategoryOpen(true)} icon={<FiPlus />} >Add Category</Button>
                </div>
            </div>


            {/* categories */}
            <div className="w-full relative mt-7">
                <Container>
                    <Table>
                        <Thead>
                            <tr>
                                <Td>Category Image</Td>
                                <Td>Category Name</Td>
                                <Td>Product Quantity</Td>
                                <Td>Actions</Td>
                            </tr>
                        </Thead>


                        {categories && categories?.length && (
                            <Tbody>
                                {categories.filter(cat => cat?.name?.toLowerCase()?.includes(searchText.toLowerCase()))?.map((cat, i) => (
                                    <tr>
                                        <Td>
                                            <Avatar size={'lg'} src={displayImage(cat?.image)} />
                                        </Td>
                                        <Td>{cat?.name}</Td>
                                        <Td>{cat?._count?.products || 0}</Td>
                                        <Td>
                                            <div className="flex items-center gap-3 text-gray-500">
                                                <Link to={`/category/${cat?.id}`}>
                                                    <CgEye size={18} />
                                                </Link>
                                                <button
                                                    className='text-primary'
                                                    title='Edit'
                                                    onClick={() => {
                                                        const searchparams = new URLSearchParams(location.search);
                                                        searchparams.set("category", cat?.id);
                                                        navigate(`${location.pathname}?${searchparams.toString()}`)
                                                        setIsUpdateCategoryOpen(true)
                                                    }}
                                                >
                                                    <FiEdit size={17} />
                                                </button>
                                                <button onClick={() => deleteCategory(cat?.id)} title='Delete' className='text-red-400'><CgTrash size={18} /></button>
                                            </div>
                                        </Td>
                                    </tr>
                                ))}
                            </Tbody>
                        )}

                    </Table>
                </Container>
            </div>

        </div>
    )
}

export default Category